module.exports = __webpack_public_path__ + "img/equifax-logo.3291567e.png";